/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NwYWNlcy9jb3Vuc2Vsb3JzL3BhZ2VzL2NvdW5zZWxvcnMtcHJvZmlsZS9jb3Vuc2Vsb3JzLXBheW1lbnQvY291bnNlbG9ycy1wYXltZW50LmNvbXBvbmVudC5jc3MifQ== */"];
export { styles as styles };
